<template>
	<div class="hhdealers__wrap" :class="[consent === true ? 'hhdealers__wrap--with-consent' : '']">
		<dealer-filter :dealers="dealers.dealers" />
		<div class="hhdealers__map__wrap" id="dealer-locator-map">
			<div id="empty-map-warning" v-if="this.getActiveFilter() === ''">{{ this.getMicroCopy().map_copy_search_select_brand }}</div>
			<gmap v-if="consent" :dealers="dealers.dealers" />
            <div v-else class="cookieconsent-optout-marketing">
                <div class="cookieconsent-optout-marketing__content">
                    <div class="cookieconsent-optout-marketing__content__txt">
                        <a v-if="hasCookiebot" href="javascript:Cookiebot.renew()">{{ getConsentLinkTxt }}</a>
                        <a v-else @click.prevent="handleConsentClick" href="#with-marketing-consent">{{ getConsentLinkTxt }}</a>
                    </div>
                </div>
            </div>
		</div>
		<dealer-list :dealers="dealers.dealers" />
	</div>
</template>

<script>
import GMap from './components/GMap'
import DealerFilter from './components/DealerFilter'
import DealerList from './components/DealerList'
import { mapActions, mapGetters } from 'vuex'
// import dealers from './assets/dealers.json'

export default {
	name: 'App',
	components: {
		'gmap': GMap,
		'dealer-filter': DealerFilter,
		'dealer-list': DealerList
	},
	data () {
		return {
			/* eslint-disable no-undef */
			dealers: typeof dealers_json !== 'undefined' ? dealers_json : null,
			micro: typeof dealers_microcopy_json !== 'undefined' ? dealers_microcopy_json: null,
            settings: typeof dealers_map_settings !== 'undefined' ? dealers_map_settings : null,
            consent: false,
            hasCookiebot: typeof vdh_gdpr !== 'undefined' && typeof vdh_gdpr.vars !== 'undefined' && vdh_gdpr.vars.has_cookiebot === true ? true : false,
            getConsentLinkTxt: typeof vdh_gdpr !== 'undefined' && typeof vdh_gdpr.vars !== 'undefined' && typeof vdh_gdpr.vars.cb_iframes_marketing_placeholder_txt !== 'undefined' ? vdh_gdpr.vars.cb_iframes_marketing_placeholder_txt : ''
		}
    },
	created () {
		this.setMicroCopy( this.micro )
        this.setDealersMapSettings(this.settings)

        window.addEventListener( 'hh-consent', this.handleConsentEvent, false );
	},
	methods: {
		...mapActions([
			'setMicroCopy',
			'setDealersMapSettings'
		]),
		...mapGetters([
			'getActiveFilter',
			'getMicroCopy'
        ]),
        handleConsentEvent() {
            // console.log('TEST: Generic hh-consent listener in VUE APP')
            this.consent = true
        },
        handleConsentClick() {
            // console.log('TEST: Generic hh-consent fired from VUE APP')
            window.dispatchEvent(
                new CustomEvent("hh-consent", {
                    bubbles: true,
                    detail: { marketing: true },
                }),
            );
        },
	}
}
</script>

<style>
/* Dev note: Changes in CSS will only be reflected on build (not on serve). */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.red {
	color: #e30817;
}

.hhdealers__wrap {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	justify-content: stretch;
}
.hhdealers__form__wrap {
	flex-basis: 100%;
	display: flex;
	align-items: stretch;
}
.hhdealers__map__wrap {
	border: 1px solid #e30817;
	/*margin-right: 45px;*/
	flex-grow: 100;

	display: flex;
	align-items: center;
	justify-content: center;
}
#empty-map-warning {
	position: absolute;
	z-index: 5000;
	padding: 2rem 3rem;
	background: #e30817;
	color: white;
	font-weight: bold;
}




.hhdealers__form {
	margin-bottom: 0 !important;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
}
.hhdealers__form__fieldset__clearbtn {
	font-size: 60%;
	opacity: 0;
	pointer-events: none;
	flex-basis: 100%;
	position: absolute;
	top: 50%;
	right: .5rem;
	z-index: 50;
	transform: translateY(-50%);
	background: white;
	display: block;
	width: 2rem;
	height: 2rem;
	border-radius: 50%;
	line-height: 2rem;
	text-align: center;
}
.hhdealers__form__fieldset__clearbtn--is-enabled {
	opacity: 1;
	pointer-events: initial;
}
.hhdealers__form__fieldset--brand input + label {
	margin-left: .5rem;
	cursor: pointer;
}
.hhdealers__form__fieldset--brand input[type=checkbox],
.hhdealers__form__fieldset--brand input[type=radio] {
	vertical-align: middle;
	margin-bottom: 4px;
	margin-top: 0;
}
.hhdealers__form__fieldset--location label {
	/* width: 100%; */
	flex-grow: 4;
	margin-bottom: 0;
	margin-left: .5rem;
	margin-right: .5rem;
	position: relative;
}
.hhdealers__form__fieldset--location button {
	border-color: #e30817;
	background-color: #e30817;
	color: white;
	border-style: solid;
}
.hhdealers__form__fieldset--location input {
	color: #333 !important;
}
.hhdealers__form__fieldset--subfilter {
	margin-left: 30px;
}
.hhdealers__form__fieldset--subfilter legend {
	display: none !important;
}
.hhdealers__form fieldset:last-child {
	margin-bottom: 0 !important;
}
.hhdealers__form > fieldset:last-child label:last-child {
	margin-bottom: 0;
}

.main_color ::placeholder {
	opacity: .4;
}
.hhdealers__form__fieldset--location {
	opacity: 0;
	pointer-events: none;
	height: 0;
}
.hhdealers__form__fieldset--location__inner {
	display: flex;
	flex-wrap: wrap;
	justify-content: stretch;
	align-items: stretch;
}
.hhdealers__form__fieldset--location legend {
	/* flex-basis: 100%; */
	width: 100%;
}
.hhdealers__form__fieldset--location--is-enabled {
	opacity: 1;
	pointer-events: initial;
	height: initial;
}


.hhdealers__results {
	margin-top: 60px;
	flex-basis: 100%;
	flex-shrink: 0;
	/*margin-right: -45px;*/
}
.hhdealers__results__inner {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
}
.hhdealers__results__header {
	flex-basis: 100%;
	margin-bottom: 30px;
	/* text-align: center; */
}
.hhdealers__result {
	flex-basis: 33%;
	flex-shrink: 1;
}
.hhdealers__result__inner {
	padding: 30px;
	/* border: 1px solid red; */
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.hhdealers__result__inner__top {
	max-width: 33rem; /* prevent collision with pro triangle */
}
.hhdealers__results__selection-fb {
	font-weight: bold;
}
.hhdealers__results__pro-info {
	margin-top: 1rem;
	margin-bottom: 1rem;
}
.hhdealers__results__pro-info ul {
	/* list-style: none;
	margin-left: 0; */
}
.hhdealers__results__pro-info i.fa-star {
	display: none;
	/* display: inline-block;
	margin-right: .5rem;
	font-size: 50%;
	color: #e30817; */
}

.hhdealers__result__address,
.hhdealers__result__phone {
	color: #65676b;
}
.hhdealers__result__phone a {
	color: #65676b;
	text-decoration: underline;
}





ul.hhdealers__result__ctas {
	margin-top: 15px;
	margin-bottom: 0;
	margin-left: 0;
	list-style-type: none;
	display: flex;
	flex-wrap: wrap;
	justify-content: stretch;
}
.hhdealers__result__ctas li {
	margin-left: 0;
	margin-right: 0;
	margin-bottom: 5px;
	width: 100%;
}
.hhdealers__result__ctas li:last-child {
	margin-bottom: 0;
}
a.hhdealers__result__cta {
	background: #e30817;
	border: 1px solid #e30817;
	color: white;
	font-size: 120%;
	text-align: center;
	display: block;
	padding: 9px 22px;
	transition: all .2s ease-out;
}
a.hhdealers__result__cta:hover,
a.hhdealers__result__cta:focus {
	background: white;
	color: #e30817;
	text-decoration: none;
}

.hhdealers__result__brands{
	/* margin-bottom: 15px; */
	margin-top: 15px;
}
ul.hhdealers__result__brandslist {
	margin-left: 0;
	margin-bottom: 0;
	margin-top: 0;
	list-style-type: none;
	display: flex;
	flex-wrap: wrap;
}
ul.hhdealers__result__brandslist .hhdealers__result__brandslist__item {
	background: white;
	color: #e30817 !important;
	border-radius: 3px;
	padding: 3px 6px;
	border: 1px solid #e30817;
	margin-left: 0;
	margin-right: .5rem;
	margin-bottom: .5rem;
}
ul.hhdealers__result__brandslist .hhdealers__result__brandslist__item.hhdealers__result__brandslist__item__pro {
	background: #e30817;
	color: white !important;
}
ul.hhdealers__result__brandslist .hhdealers__result__brandslist__item.hhdealers__result__brandslist__item__pro:after {
	content: 'PRO';
	display: inline-block;
	margin-left: .1rem;
}



a.hhdealers__result__pro-btn {
	background: #e30817;
	border: 1px solid #e30817;
	color: white;
	text-transform: uppercase;
	font-size: 120%;
	text-align: center;
	display: inline-block;
	margin-top: 10px;
	padding: 9px 22px;
	transition: all .2s ease-out;
}
a.hhdealers__result__pro-btn .fa {
	margin-left: 1rem;
}
a.hhdealers__result__pro-btn:hover,
a.hhdealers__result__pro-btn:focus {
	background: white;
	color: #e30817;
	text-decoration: none;
}

.hhdealers__map__wrap .hhdealers__result {
	width: 40rem;
	max-width: 40rem;
}
.hhdealers__map__wrap .hhdealers__result__inner {
	padding: 0 10px;
}



.hhdealers__results .hhdealers__result {
	padding-right: 30px;
	margin-bottom: 30px;
	display: flex;
	align-items: stretch;
	justify-content: stretch;
}
.hhdealers__results .hhdealers__results__inner {
	margin-right: -45px;
}
.hhdealers__results .hhdealers__result__inner {
	border: 1px solid #e1e1e1;
	/* border-color: #e30817; */
}



.hhdealers__result__pro {
	position: absolute;
	right: 0;
	top: 0;
	display: block;
	padding: 10px;
	width: 110px;
	height: 110px;
	
	color: white;
	font-size: 10px;
	text-align: right;
}
/* .hhdealers__result__pro:hover {

} */
/* .hhdealers__result__pro a {
	transition: all 0.1s ease-in-out;
	display: block;
	padding: 10px;
	width: 110px;
	height: 110px;
	color: white;
	position: relative;
} */
/* .hhdealers__result__pro a:hover,
.hhdealers__result__pro a:focus {
	transform: scale(1.2);
	transform-origin: top right;
	font-size: 12px;
	color: white !important;
	text-decoration: none !important;
} */
.hhdealers__result__pro:before {
	position: absolute;
	z-index: -1;
	display: block;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	content: '';
	-webkit-clip-path: polygon(100% 0, 60% 0, 100% 40%);
	clip-path: polygon(100% 0, 0% 0, 100% 100%);
	background: #e30817;
	display: inline-block;
}
.hhdealers__result__pro__label {
	font-size: 14px;
	font-weight: bold;
}
.hhdealers__result__pro__brand {
	display: block;
	line-height: 1.1;
}



.button {
	display: inline-block;
	min-width: 20rem;
}
.screen-reader-text {
	position: absolute;
	top: auto;
	left: -999em;
	right: auto;
	height: 0;
	overflow: hidden;
}

/* inverse colours for pro */
.hhdealers__result--pro .hhdealers__result__inner {
	border-color: #e30817;
}
/*
.hhdealers__result--pro .hhdealers__result__inner {
	background: #e30817;
	border-color: #e30817;
}
.hhdealers__result--pro .hhdealers__result__pro:before {
	background: white;
	z-index: 2;;
}
.hhdealers__result--pro .hhdealers__result__pro {
	color: #e30817;
}
.hhdealers__result--pro ul.hhdealers__result__brandslist .hhdealers__result__brandslist__item {
	background: #e30817;
	color: white !important;
	border: 1px solid white;
}
.hhdealers__result--pro ul.hhdealers__result__brandslist .hhdealers__result__brandslist__item.hhdealers__result__brandslist__item__pro {
	background: white;
	color: #e30817 !important;
}
.hhdealers__result--pro a.hhdealers__result__cta {
	/* background: white; * /
	border: 1px solid white;
	color: #e30817;
}
.hhdealers__result--pro a.hhdealers__result__cta:hover,
.hhdealers__result--pro a.hhdealers__result__cta:focus {
	/* background: #e30817; * /
	/* color: white; * /
}
.hhdealers__result--pro .hhdealers__result__address,
.hhdealers__result--pro .hhdealers__result__phone,
.hhdealers__result--pro h3 {
	color: white;
}
.hhdealers__result--pro .hhdealers__result__phone a {
	color: white;
}
*/





@media only screen and (min-width: 851px) {
	.hhdealers__form__wrap {
		flex-basis: 30.5%;
		margin-right: 30px;
	}
	a.hhdealers__result__pro-btn {
		/* transform: translateX(-22px); */
		margin-right: 0;
	}
}

@media only screen and (max-width: 850px) {
	.hhdealers__map__wrap {
		display: block;
		min-height: 50vh;
		width: 100%;
		margin-right: 0;
		margin-top: 45px;
	}
	.hhdealers__results {
		margin-top: 30px;
	}
	.hhdealers__results .hhdealers__results__inner {
		margin-right: -30px;
	}
	.hhdealers__result {
		flex-basis: 50%;
		flex-grow: 0;
		overflow-x: hidden;
	}
	a.hhdealers__result__pro-btn {
		margin-right: 30px;
	}
}
@media only screen and (max-width: 600px) {
	.hhdealers__results  .hhdealers__results__inner {
		margin-right: -30px;
	}
	.hhdealers__result {
		flex-basis: 100%;
		padding-right: 0;
	}

	.hhdealers__map__wrap .hhdealers__result {
		width: 40rem;
		max-width: 100%;
	}
}


/* Consent */
#dealer-locator-map {
  position: relative;
  min-height: 30rem;
}
.cookieconsent-optout-marketing {
    z-index: 5001;
}
.hhdealers__form__fieldset--location {
    visibility: hidden;
}
.hhdealers__wrap--with-consent .hhdealers__form__fieldset--location {
    visibility: visible;
}

.hhdealers__result__ctas li:last-child {
    display: none;
}
.hhdealers__wrap--with-consent .hhdealers__result__ctas li:last-child {
    display: block;
}

</style>
